
import externalConfiguration from '../external-configuration';
import { avoidCache, patchM3u8Url, isIE11, IE11_safeFrameElement } from './utils';

function legacyPlayerReadData_playlist( player) {
  let data = {};
  let color = parseInt( player.settings.controls.color.replace('0x', ''), 16);
  let alpha = player.settings.controls.alpha;
  data.customProps = {
    autostart: player.settings.autoplay,
    skin: {        // Esto deberia parametrizarse en admin player, y referenciar skins auto-alojados
    	name: 'glow',
    	active: '#666666',
    	inactive: '#aaaaaa',
    	background: 'rgba(' + ((color >> 16) & 255) + ', ' + ((color >> 8) & 255) + ', ' + (color & 255) + ', ' + alpha + ')',
    },
  };
  if( player.settings.controls.share.visible === 'true') {   // Este bloque construye la seccion de compartir si es necesario
    let code = IE11_safeFrameElement();
    if( !code) {
      code = '<iframe src="' + document.URL + '"></iframe>';
    }
    let networks = player.settings.controls.share.network;
    let keys = Object.keys(networks);
    let sites = [];
    for (let i = 0; i < keys.length; i++) {
      let site = keys[i];
      if( networks[site]){
        if( site === 'google') {
          site = 'googleplus';
        } else if (site === 'mail') {
          site = 'email';
        } else {
          site = site.toLowerCase();
        }
        sites[i] = site;
      }
    }
    data.customProps.sharing = {
      code: code,
      link: /src=["']([^"']*)["']/.exec(code)[1],
      sites: sites,
    };
  }
  // if( player.settings.logo.visible === 'true')) {  // Este bloque construye la seccion del logo si es necesario
  let src = player.settings.logo.src;
  if( src !== '') {
    const positions = [ 'top-left', 'top-left', 'top-right', 'bottom-left', 'top-right', 'bottom-left', 'bottom-right', 'bottom-right'];
    data.customProps.logo = {
      file: avoidCache( src),
      link: avoidCache( player.settings.logo.url),
      position: positions[ parseInt( player.settings.logo.pos, 10)],
    };
  }
  // data.playlist = [{  // Esta playlist sera el elemento reproducible, si es live, si es vod, solo el campo 'adschedule' contiene informacion valida, si se va a usar para reproducir una playlist incluso ese sera sobreescrito
  //   image: avoidCache( player.prevPic),
  //   file: avoidCache( player.src),
  // }];
  // let pre = player.settings.videoAds.pre_roll;    // Este bloque construye la seccion de publicidad si es necesario
	// let mid = player.settings.videoAds.mid_roll;
	// let post = player.settings.videoAds.pos_roll;
	// let pre_jump = player.settings.videoAds.jmPnt_Pre;
	// let mid_jump = player.settings.videoAds.jmPnt_Mid;
  // let advertising = {
  //   client: 'vast',
  // };
  // let adschedule = {}
	// if( pre !== '' && pre !== 'false') {
  //   adschedule.adbreak1 = {
  //     offset: 'pre',
  //     tag: pre,
  //     skipoffset: pre_jump,
  //   };
	// }
	// if( mid !== '' && mid !== 'false') {
  //   adschedule.adbreak2 = {
  //     offset: '50%',
  //     tag: mid,
  //     skipoffset: mid_jump,
  //   };
	// }
  // if( post !== '' && post !== 'false') {
  //   adschedule.adbreak3 = {
  //     offset: "post",
  //     tag: post,
  //   };
  // }
  // if( Object.keys( adschedule).length !== 0) {
  //   data.customProps.advertising = advertising;
  //   data.playlist[0].adschedule = adschedule;
  // }
  data.debug = {
    imageFromPlayerPrevPic: player.prevPic,
    imageFromPlayerXMLVidPic: player.settings.controls.vidPic,
    fileFromPlayerSrc: player.src,
    fileFromPlayerSrcMobile: player.srcMobile,
  };
  data.basePlayerOptions = { download: player.settings.controls.share.download };
  return data;
}

function legacyRestrictionsReadData_playlist( settings) {
  return {
    playbackRestrictions: {
      domainBlockActive: settings.domains.length !== 0,
      domainsBlocked: settings.domains,
      countryBlockActive: Object.keys( settings.regions).length !== 0,
      countriesBlocked: settings.regions,
      displayImageWhenBlock: externalConfiguration.defaultBlockImage,   // settings.img,    // una vez que se le configure un valor valido
    },
  };
}

function readProgrammationSettings( settings, restrictionSettings, programmation) {
  settings.customProps.repeat = true;
  let startFromVideo = 0;
  let startFromSecond = 0;
  let now = new Date();
  if( programmation.publish === 1 || programmation.publish === '1') {
    let start = new Date( programmation.initDate);
    let startToday = new Date( now.getFullYear(), now.getMonth(), now.getDate(), start.getHours(), start.getMinutes(), start.getSeconds());
    if( now < startToday) {
      startToday.setDate( now.getDate() - 1);
    }
    if( now >= start) {
      if( programmation.continualLoop === 1 || programmation.continualLoop === '1') {
        startFromSecond = (now - start) / 1000 % programmation.totalDuration;
        restrictionSettings.playbackRestrictions.unpublishDate = new Date( programmation.finalDate);
        settings.basePlayerOptions.programmationInfo = { mode: 'continualLoop', finalDate: new Date( programmation.finalDate)};
      } else if( programmation.diary === 1 || programmation.diary === '1') {
        startFromSecond = (now - startToday) / 1000;
        restrictionSettings.playbackRestrictions.unpublishDate = new Date( startToday.getTime() + programmation.totalDuration * 1000);
        settings.basePlayerOptions.programmationInfo = { mode: 'diary', finalDate: new Date( programmation.finalDate)};
      } else {
        startFromSecond = (now - start) / 1000;
        restrictionSettings.playbackRestrictions.unpublishDate = new Date( start.getTime() + programmation.totalDuration * 1000);
        settings.basePlayerOptions.programmationInfo = { mode: 'simple', finalDate: restrictionSettings.playbackRestrictions.unpublishDate};
      }
      settings.basePlayerOptions.programmationInfo.effectiveTimeStampStart = new Date(now.getTime() - startFromSecond * 1000);
      settings.playlist.some( (e,i) => {
        if( startFromSecond <= e.duration){
          return true;
        }
        startFromSecond -= e.duration;
        startFromVideo += 1;
        return false;
      });
      settings.basePlayerOptions.disableManualSeek = true;
      settings.customProps.autostart = true;   // Cuando alguna de las dos siguientes tiene un valor distinto de 0, el autostart es implicito; se pone explicito para el caso particular 0,0
      settings.basePlayerOptions.startFromVideo = startFromVideo;
      settings.basePlayerOptions.startFromSecond = startFromSecond;
    }
    restrictionSettings.playbackRestrictions.publishDate = programmation.initDate;
  }
  if( 'headerVastUrl' in programmation && programmation.headerVastUrl !== '' && now < restrictionSettings.playbackRestrictions.unpublishDate) {
    if( !( 'adschedule' in settings.playlist[ startFromVideo])) {
      settings.playlist[ startFromVideo].adschedule = {};
    }
    if( !( 'headerTimeSkip' in programmation)) {
      programmation.headerTimeSkip = 0;
    }
    settings.playlist[ startFromVideo].adschedule.videoHeader = {
      offset: 'pre',
      skipoffset: programmation.headerTimeSkip,
      tag: avoidCache( programmation.headerVastUrl),
    };
  }
}

function playlistToState( id) {
  let settings = {
    legacy: true,
    visualizerType: 'Playlist',
  };
  let commonCustomProps = {
    hlshtml: true,
    primary: isIE11() ? 'flash' : 'html5',
    abouttext: externalConfiguration.defaultPlayerAboutText,
    aboutlink: externalConfiguration.defaultPlayerAboutLink,
    width: window.innerWidth,
    height: window.innerHeight,
    advertising: { client: 'vast', },
  };
  settings.visualizerOptions = {
    onResize: ( state) => { state.customProps.width = window.innerWidth; state.customProps.height = window.innerHeight; return state;},
  }
  let promiseOfPlaylist = fetch( avoidCache( '/definition/jwPlaylist/' + id + '.json')).then( (response) => { return response.json();});
  return promiseOfPlaylist.then( (playlist) => {
    let player = playlist.player;
    let restrictionSettings = legacyRestrictionsReadData_playlist( player.accessControl);
    let settings = legacyPlayerReadData_playlist( player);
    settings.playlist = playlist.jwPlaylist.map( element => {
      if( !( 'urlFields' in element)) element.urlFields = externalConfiguration.jwPlaylistDefaultUrlFields;
      element.urlFields.forEach( url => element[url] = patchM3u8Url( element[url]));
      return element;
    });
    readProgrammationSettings( settings, restrictionSettings, playlist.programmation);
    return { ...restrictionSettings, ...settings};
  }).then( (typeSettings) => {
    Object.assign( settings, typeSettings);
    Object.assign( settings.customProps, commonCustomProps);
    return settings;
  });
}

export default playlistToState;



// WEBPACK FOOTER //
// ./src/helpers/playlist-to-state.js